<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <div v-if="revert_user" class="row mb-3 d-flex">
        <div class="col-12 col-md-8 pr-0">
          <h5 style="font-size: 1.2rem;">
            Original User: {{ revert_user.name }} ({{ revert_user.email }})
          </h5>
        </div>
        <div class="col-12 col-md-4 pl-0">
          <a v-if="revert_user"
             href="/user/revert-to-admin"
             class="btn btn-ss w-100">
            <i class="flaticon2-cardiogram" />
            <span>Revert To Original User</span>
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-if="customers_with_users.length" class="mb-3">
            <multiselect
              v-model="selected_customer"
              placeholder="Select a Customer"
              :allow-empty="false"
              :filterable="true"
              :options="customers_with_users"
              label="name"
              track-by="uuid" />
          </div>
          <div v-if="selected_customer" class="mb-3">
            <multiselect
              v-if="selected_customer.users.length"
              v-model="selected_user"
              placeholder="Select a User"
              :allow-empty="false"
              deselect-label=""
              :filterable="true"
              :options="selected_customer.users"
              :custom-label="customUserLabel"
              label="name"
              track-by="uuid">
              <template #singleLabel="props">
                {{ props.option.name }} ({{ props.option.email }})
              </template>
              <template #option="props">
                {{ props.option.name }} ({{ props.option.email }})
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <p v-if="selected_customer && (!selected_customer.users || !selected_customer.users.length)">
            <strong>Customer has no Users</strong>
          </p>
          <b-dropdown v-if="selected_user"
                      split
                      :text="`Login as ${selected_user.name}`"
                      variant="ss-standout"
                      @click="() => loginAsUser(selected_user)">
            <b-dropdown-item-button v-for="pt in plan_type_options"
                                    :key="pt"
                                    @click="() => selectPlanThenLogin(pt, selected_user)">
              Login as {{ capitalise(pt) }}
            </b-dropdown-item-button>
          </b-dropdown>
          <button v-if="selected_user && !selected_user_is_verified" class="btn btn-ss" @click="manuallyVerifyUserEmail(selected_user)">
            Manually Verify Email
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleAxiosError } from "Helpers/responses";
import PlanTypesMixin from "VueMixins/PlanTypesMixin";
import { capitalise } from "Lib/string-util";

export default {
  mixins: [PlanTypesMixin],
  data: () => ({
    customers_with_users: [],
    selected_customer: null,
    selected_user: null,
  }),
  computed: {
    selected_user_is_verified() {
      return this.selected_customer && this.selected_user?.email_verified_at;
    },
    plan_type_options() {
      return [
        ...this.plan_types,
        // ...['default'], // uncomment later if we figure out what it means to have no plan type
      ];
    },
    revert_user() {
      if (!window.revert_to_admin) {
        return null;
      }
      const users = this.customers_with_users.reduce((acc, customer) => [
        ...acc,
        ...customer.users,
      ], []);
      return users.find(user => user.id === window.revert_to_admin.user_id);
    },
  },
  watch: {
    selected_customer: {
      deep: true,
      handler() {
        this.selected_user = this.selected_customer.users[0];
      },
    },
  },
  mounted() {
    this.getCustomersWithUsers();
  },
  methods: {
    capitalise,
    async getCustomersWithUsers() {
      try {
        const response = await axios.get('/api/v1/admin/customer?login_as_user=true');
        if (response.data) {
          this.customers_with_users = response.data.data.data;
        }
        if (this.revert_user) {
          this.selected_customer = this.customers_with_users.find(customer => customer.users.find(user => user.id === this.revert_user.id));
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    customUserLabel({ name, email }) {
      return `${name} (${email})`;
    },
    manuallyVerifyUserEmail(user) {
      axios.patch(`/api/v1/admin/user/${user.uuid}/verify-email`).then((response) => {
        this.selected_user = response.data.data;
        toastr.success("User Email Verified");
      }).catch((error) => {
        this.handleAxiosError(error);
      });
    },
    loginAsUser(user) {
      if (user && user.uuid) {
        axios.post(`/admin/tools/login-as-user/${user.uuid}`).then((response) => {
          if (response.data.data) {
            toastr.success("Logging you in");
            window.location.href = "/";
          }
        }).catch((error) => {
          handleAxiosError(error);
        });
      }
    },
    async selectPlanThenLogin(plan_type, user) {
      this.selectPlanType(plan_type);
      await this.overridePlanType();
      this.loginAsUser(user);
    },
  },
};
</script>
